import { jsxs, jsx } from 'react/jsx-runtime';
import { SidenavGroupItem } from '../Sidenav.Group.Item/Sidenav.Group.Item.es.js';

const SidenavGroup = ({ heading, as: HeadingTag = 'h2', children })=>{
    return jsxs("span", {
        className: "cb-sidenav-group",
        "data-testid": "sidenav-group",
        children: [
            jsx(HeadingTag, {
                className: "heading",
                children: heading
            }),
            jsx("span", {
                className: "group-items",
                children: children
            })
        ]
    });
};
SidenavGroup.displayName = 'Sidenav.Group';
SidenavGroup.Item = SidenavGroupItem;

export { SidenavGroup };
//# sourceMappingURL=Sidenav.Group.es.js.map
